import {FC} from 'react'
import {DictionarySelector, DictionarySelectorProps} from './DictionarySelector'

export const TrustedStatusSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="trustedStatus"
                        loader={() => Promise.resolve([
                            {id: 'true', name: 'Trusted'},
                            {id: 'false', name: 'Untrusted'}
                        ])}
    />